import React from "react";

export const Footer: React.FC<{ data: any }> = props => {
  if (props.data) {
    var networks = props.data.social.map(function(network: any) {
      return (
        <li key={network.name}>
          <a href={network.url}>
            <i className={network.className}></i>
          </a>
        </li>
      );
    });
  }

  return (
    <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social-links">{networks}</ul>

          <ul className="copyright">
            <li>&copy; Copyright 1995-{new Date().getFullYear()}</li>
            <li>
              Design by{" "}
              <a title="Styleshout" href="http://www.styleshout.com/">
                Styleshout
              </a>
            </li>
            <li>
              Layout by{" "}
              <a
                title="Styleshout"
                href="https://github.com/tbakerx/react-resume-template"
              >
                T. Baker
              </a>
            </li>
          </ul>
        </div>
        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="#home">
            <i className="icon-up-open"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};
